import React, { useEffect, useState } from 'react'
import '../style/hero.css'

const HeroSection = ({ image, text }) => {
  const [showText, setShowText] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowText(true)
    }, 1000)
    return () => clearTimeout(timer)
  }, [])

  return (
    <section
      className="hero"
      style={{ backgroundImage: `url(${image})` }}
    >
      <div className={`hero-text ${showText ? 'visible' : ''}`}>
        <h1>{text}</h1>
      </div>
    </section>
  )
}

export default HeroSection;
